import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

const uc = (s: string) => s.toLocaleUpperCase();

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getCurrencyLabel = (code: string) =>
  uc(code) === "CAD" ? "CUP" : uc(code);

export const mapCurrencyforBackend = (code: string) => {
  const c = uc(code);
  if (c === "CUP") return "cad";
  return c.toLowerCase();
};

export const formatCurrency = (n: number, code: string) => {
  const label = getCurrencyLabel(code);

  const formatter = new Intl.NumberFormat(undefined, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${formatter.format(n)} ${label}`;
};

export const formatPrice = (amount: number, currencyCode: string) => {
  return formatCurrency(amount, currencyCode)
};

export const getOptionsFromStringArr = (arr: string[]) =>
  arr.map((v) => ({ value: v, label: v }));

export const getSymbol = (currency: string) => {
  switch (currency) {
    case "EUR":
      return "€";
    case "USD":
      return "$";
    case "CAD":
      return "$"; // Listed as CUP in UI
    default:
      return "$";
  }
};